<template>
  <empty-layout>
    <div
      class="w-full"
      :class="{
        'top-0': !showHeader,
        'top-navbar-height': showHeader,
      }"
    >
      <div class="w-full">
        <div
          id="profileBanner"
          class="relative h-[116px] w-full"
          :class="{ '!h-[240px]': isIos }"
        ></div>
      </div>
      <div class="flex justify-center">
        <div
          class="z-10 w-full mx-6 lg:w-[504px] lg:mx-0 mt-[-42px] inline-flex lg:flex flex-col items-left gap-[24px]"
        >
          <div>
            <div
              v-if="!showProfilePic"
              :class="[
                'flex items-center w-[84px] h-[84px] text-[#FFF] text-[40px] font-family-[\'aktiv-grotesk-medium\'] justify-center leading-loose rounded-full border-white border-[3px]',
                isGICConfType ? 'bg-orange' : 'bg-lightblue',
              ]"
            >
              {{ userDetails.name.charAt(0) }}
            </div>
            <img
              v-if="showProfilePic"
              :src="userDetails.profilePicture"
              class="w-[84px] h-[84px] items-left rounded-full border-white border-[3px]"
            />
          </div>
          <div class="flex flex-col w-full gap-2 text-left justify-left">
            <div
              class="w-full font-semibold text-[24px] leading-[32px] font-['Proxima Nova'] text-[#1B2A6B]"
            >
              {{ userDetails.name }}
            </div>
            <div class="w-full">
              <div class="text-[16px] leading-[24px] font-aktiv-grotesk-regular">
                {{ userDetails.organization }}
              </div>
              <div class="font-normal text-[16px] leading-[24px] font-aktiv-grotesk-regular">
                {{ userDetails.title }}
              </div>
            </div>
          </div>
          <div
            v-if="
              showEmail() ||
              userDetails.instagram ||
              userDetails.facebook ||
              userDetails.x ||
              userDetails.linkedin
            "
            class="flex flex-col w-full p-6 rounded-[24px] bg-white border-solid border-[1px] border-grey-20"
          >
            <div v-if="showEmail()" class="mb-5">
              <div class="w-full font-semibold text-[16px] leading-[24px]">
                {{ $t('copy.profilePage.email') }}
              </div>
              <div
                :class="[
                  'w-full font-normal text-[16px] leading-[24px]',
                  isGICConfType ? 'text-orange' : 'text-lightblue',
                ]"
              >
                {{ userDetails.email }}
              </div>
            </div>
            <div
              v-if="
                userDetails.instagram ||
                userDetails.facebook ||
                userDetails.x ||
                userDetails.linkedin
              "
              class="w-full font-semibold text-[16px] leading-[20px] mb-3"
            >
              {{ $t('copy.profilePage.socials') }}
            </div>
            <div class="flex flex-row w-full">
              <a
                v-if="userDetails.instagram"
                class="w-[32px] h-[32px] mr-6"
                :href="instagramURL()"
                target="_blank"
              >
                <img
                  src="../../../../public/assets/icons/logo-instagram.svg"
                  alt="Instagram Social"
                />
              </a>
              <a
                v-if="userDetails.facebook"
                class="w-[32px] h-[32px] mr-6"
                :href="facebookURL()"
                target="_blank"
              >
                <img
                  src="../../../../public/assets/icons/logo-facebook.svg"
                  alt="Facebook Social"
                />
              </a>
              <a v-if="userDetails.x" class="w-[32px] h-[32px] mr-6" :href="xURL()" target="_blank">
                <img src="../../../../public/assets/icons/logo-twitterx.svg" alt="X Social" />
              </a>
              <a
                v-if="userDetails.linkedin"
                class="w-[32px] h-[32px]"
                :href="linkedInURL()"
                target="_blank"
              >
                <img
                  src="../../../../public/assets/icons/logo-linkedin.svg"
                  alt="LinkedIn Social"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </empty-layout>
</template>

<script>
import EmptyLayout from '@/components/EmptyLayout.vue';
import axios from 'axios';
import VCard from 'vcard-creator';

export default {
  name: 'PubProfile',
  components: {
    EmptyLayout,
  },
  data() {
    return {
      userDetails: {
        name: '',
        organization: '',
        title: '',
        email: '',
        emailFlag: false,
        instagram: '',
        facebook: '',
        x: '',
        linkedin: '',
        profilePicture: '',
      },
      showProfilePic: false,
      profileUrl: '',
      isSamsung: false,
    };
  },
  async created() {
    const hashId = this.$route.params.id;
    const { status, data } = await axios.get(
      process.env.VUE_APP_API_URL + '/socialprofile/public?id=' + hashId,
    );
    if (status !== 200) {
      return;
    }

    this.userDetails = data.socialprofile;
    this.showProfilePic = this.userDetails?.profilePicture;
  },
  mounted() {
    if (navigator.userAgent.match(/samsung/i)) {
      this.isSamsung = true;
    }
  },
  methods: {
    instagramURL() {
      return 'https://www.instagram.com/' + this.userDetails.instagram; // Remove as string when store has been re-adjusted
    },
    facebookURL() {
      return 'https://www.facebook.com/' + this.userDetails.facebook;
    },
    xURL() {
      return 'https://www.x.com/' + this.userDetails.x;
    },
    linkedInURL() {
      return 'https://www.linkedin.com/in/' + this.userDetails.linkedin;
    },
    showEmail() {
      return this.userDetails.email;
    },
    async generateVcf() {
      // Define a new vCard
      const myContact = new VCard();
      // Add personal data
      myContact.addName('', this.userDetails.name, '', '', '');
      // Add work data
      if (this.userDetails.organization) {
        myContact.addCompany(this.userDetails.organization);
      }
      if (this.userDetails.title) {
        myContact.addJobtitle(this.userDetails.title);
      }
      if (this.showEmail() && this.userDetails.email) {
        myContact.addEmail(this.userDetails.email);
      }

      if (this.userDetails.x) {
        myContact.addSocial(this.xURL(), 'Twitter');
      }

      if (this.userDetails.instagram) {
        myContact.addSocial(this.instagramURL(), 'Instagram');
      }

      if (this.userDetails.facebook) {
        myContact.addSocial(this.facebookURL(), 'Facebook');
      }

      if (this.userDetails.linkedin) {
        myContact.addSocial(this.linkedInURL(), 'linkedin');
      }
      if (this.userDetails.profilePicture) {
        const base64 = await this.getBase64Image(this.userDetails.profilePicture);
        myContact.addPhoto(base64);
      }

      // Create a Blob from the vCard data
      const blob = new Blob([myContact], { type: 'text/vcard' });

      // Create a URL for the Blob
      const myContactUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = myContactUrl;
      link.download = 'profile.vcf';

      // Append the link to the body
      document.body.appendChild(link);

      // Programmatically click the link to trigger the download
      link.click();

      // Remove the link from the body
      document.body.removeChild(link);

      URL.revokeObjectURL(this.profileUrl); // Clean up the URL
    },
    async getBase64Image(imgUrl) {
      const response = await fetch(imgUrl, { cache: 'no-cache' });
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      this.profileUrl = url;
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = url;
      await new Promise(resolve => (img.onload = resolve));
      const canvas = document.createElement('canvas');
      canvas.width = 640;
      canvas.height = 640;
      canvas.getContext('2d').drawImage(img, 0, 0, 640, 640);
      const dataUrl = canvas.toDataURL('image/png');
      const base64 = dataUrl.split(',')[1];
      return base64;
    },
  },
};
</script>
<style scoped>
@media (min-width: 769px) {
  #profileBanner {
    background-color: #fddb00;
    background-size: 100% 100%; /* Stretch image to cover entire area */
    background-repeat: no-repeat; /* Prevent image from repeating */
    background-position: center; /* Center the background image */
  }
}

@media (max-width: 768px) {
  #profileBanner {
    background-color: #fddb00;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
  }
}
</style>
